<template>
  <AppLayout>
    <div class="transaction" :key="componentKey">
      <section id="transaction-products">
        <div class="container">
  
          <h6 style="margin-bottom: 0px;" class="fw-bold">Manage Stocks - Stock Levels
            <!--<div class="btn-group" role="group" style="float:right;">
                <button type="button" class="btn btn-style small dropdown-toggle" style="border: 1px solid black; margin-left: 10px;" data-bs-toggle="dropdown" aria-expanded="false">More Action</button>
                <ul class="dropdown-menu">
                    <li><a class="dropdown-item" href="#">Low Stock Report</a></li>
                    <li><a class="dropdown-item" href="#">Reorder Report</a></li>
                    <li><a class="dropdown-item" href="#">Stock Variance Report</a></li>
                    <li><a class="dropdown-item" href="#">Stock Adjustment Report</a></li> 
                </ul>
            </div>-->
          </h6>
          <div class="warehouse-inventory-card-wrapper">
            <div class="warehouse-inventory-card">
              <p>No. Items in <br>
                Warehouses</p>
              <strong>{{ uniqueItemsCount }}</strong>
            </div>
  
            <div class="warehouse-inventory-card">
              <p>Low Stock <br>
                Level Items</p>
              <strong class="red">{{ lowStockCount }}</strong>
            </div>
  
            <div class="warehouse-inventory-card">
              <p>Reorder <br>
                Items</p>
              <strong>{{ reorderCount }}</strong>
            </div>
  
            <div class="warehouse-inventory-card">
              <p>Items marked  <br>
                for return</p>
              <strong>{{ itemsMarkedForReturnCount }}</strong>
            </div>
  
            <div class="warehouse-inventory-card">
              <p>Value of <br>
                Stock Lost </p>
              <strong>{{ valueStockLost }}</strong>
            </div>
  
            <div class="warehouse-inventory-card">
              <p>Stock on Hand <br>
                Value</p>
              <strong class="green">{{ stockOnHandValue }}</strong>
            </div>
  
          </div> 
  
          <div class="filter-search" style="margin-top: 0px;padding-left: 0px;">
            <div class="filter-search-header">
              <p>Filter</p>
              <p class="clear" @click="clear">Clear</p>
            </div>
            <div class="filter-search-body">
              <div class="form">
                <div class="row">
                  <div class="col-md-4 align-self-end">
                    <label>Product</label>                    
                    <Select2 class="select2" v-if="products.length > 0" style="width: 100% !important; height: 40px !important" v-model="productId" :options="productOptions" :settings="{ width: 'resolve', selectionCssClass: ':all:' }" />
                    <div v-else>
                        <button class="btn btn-primary btn-sm" @click="this.fetchProducts">Fetch Products</button>
                    </div>
                  </div>
                  <div class="col-md-3 align-self-end">
                    <label for="product-category">Product Category</label>
                    <select v-model="categoryId" class="full" id="product-category"  v-if="categories.length > 0">
                      <option value="0">All</option>
                        <option v-for="category in categories" v-bind:Key="category.id" :value="category.id">
                            {{ category.category }}
                        </option>
                    </select>
                    <div v-else>
                        <button class="btn btn-primary btn-sm" @click="this.fetchCategories">Fetch Product Categories</button>
                    </div>
                  </div>
                  <div class="col-md-3 align-self-end">
                      <label for="product-sub-category">Product Sub-category</label>
                      <select v-model="subCategoryId" class="full" id="product-sub-category">
                          <option value="0">None</option>
                          <option v-for="subcategory in subcategories" v-bind:Key="subcategory.id" :value="subcategory.id">
                              {{ subcategory.category }}
                          </option>
                      </select>
                  </div>
                  <div class="col-md-2 align-self-end">
                    <label for="">Stock Levels</label>
                    <select class="full" id="stock-level" v-model="stock">
                      <option value="all">Any</option>
                      <option value="over">Over Stocked</option>
                      <option value="normal">Normal</option>
                      <option value="low">Low</option>
                      <option value="out">Out of Stock</option>
                    </select>
                  </div>
                  <div class="col-md-4 align-self-end">
                    <label for="supplierContact">Warehouse</label>
                    <select v-model="warehouseId" class="full" id="warehouses"  v-if="warehouses.length > 0">
                      <option value="0">All</option>
                      <option v-for="warehouse in warehouses" v-bind:Key="warehouse.id" :value="warehouse.id">
                          {{ warehouse.name }} <span v-if="warehouse.isVirtual == true"> - virtual</span>
                      </option>
                    </select>
                        <div v-else>
                        <button class="btn btn-primary btn-sm" @click="this.fetchWarehouses">Fetch Warehouses</button>
                    </div>
                    
                    
                
                  </div>
                  <div class="col-md-1">
                    <div style="display:flex; gap:6px; margin-top: 37px;">
                      <button class="btn btn-primary" type="button" @click="search">Search</button>
                      <!--<button class="btn btn-outline-primary" type="button" @click="exportToCSV" :disabled="loading">Export CSV</button>-->
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
  
          <div class="products-list transaction-products-list" style="margin-top: 0px;">
            <!--<strong style="margin-top: 0px;">Stock Item List</strong>
             <keep-alive> -->
            
            <!-- Skeleton loader for stock table -->
            <SkeletonLoader v-if="loading" type="table" :rows="8" :columns="13" />
            
            <table v-else class="table table-hover" id="stocksTable">
              <thead>
                <th>No.</th>
                <th>Product Description</th>
                <th>Code</th>
                <th>Category</th>
                <th>Sub-Category</th>
                <th>Unit</th>
                <th>On Hand</th>
                <th>Qty Reserved</th>
                <th>Qty Available</th>
                <th>SOH Value(Kshs)</th>
                <th>Stock Level</th>
                <th>Warehouse</th>
                <th>Action</th>
              </thead>
              
            </table>
            <LoaderItem v-if="loading"/>
          <!-- </keep-alive> 
            <div v-if="activities.length < 1">
              <label for="" class="alert alert-danger" style="margin: 0px auto; width: fit-content; display: block;">No item found</label>
            </div>-->
          </div>
        </div>
      </section>
    </div>
  </AppLayout>
  </template>
  
  <script>
  import { docFooter } from '../../utils/common'
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.html5.js';
  import 'datatables.net-buttons/js/buttons.colVis.js';
  import 'datatables.net-buttons/js/buttons.print.js';
  import { mapGetters, mapActions } from 'vuex'
  import Swal from 'sweetalert2'
  import AppLayout from '../../components/AppLayout.vue';
  import Select2 from 'vue3-select2-component';
  import 'datatables.net-vue3';
  import 'datatables.net-bs5';
  import "datatables.net-buttons-bs5";
  import "datatables.net-responsive-bs5";
  import $ from 'jquery';
  import 'jszip';
  import LoaderItem from '../../components/LoaderItem'
  import SkeletonLoader from '../../components/SkeletonLoader'

  export default {
    name: 'ManageStocks',
    components: {
      AppLayout,
      Select2,
      LoaderItem,
      SkeletonLoader
    },
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        activities: [],
        products: [],
        productId: "0",
        categoryId: "0",
        warehouseId: "0",
        productOptions:[],
        subCategoryId: "0",
        subcategories: [],
        dataTable:  null,
        processedData: [],
        componentKey: 0, 
        loading: false,
        activitiesDatas: [],
        stock: "",
        activeId: ""

    }),
    computed:{
        ... mapGetters (["getCategories", "getWarehouses", "getProductOptions"]),
        categories () { return this.getCategories },
        warehouses () { return this.getWarehouses },
        uniqueItemsCount() {
          const set = new Set();
          const list = this.activities || [];
          list.forEach(a => {
            const id = a?.Product?.id || a?.productId || a?.ProductId;
            if (id) set.add(id);
          });
          const count = set.size || (this.products?.length || 0);
          try { return this.formatQty(count); } catch(e) { return count; }
        },
        lowStockCount() {
          const list = this.activities || [];
          return list.filter(a => (a?.stock || '').toString().toLowerCase() === 'low').length;
        },
        reorderCount() {
          const keys = ['order','reorder','re-order'];
          const list = this.activities || [];
          return list.filter(a => keys.includes((a?.stock || '').toString().toLowerCase())).length;
        },
        itemsMarkedForReturnCount() {
          const list = this.activities || [];
          return list.filter(a => a?.markedForReturn === true || a?.isMarkedForReturn === true || a?.forReturn === true).length;
        },
        valueStockLost() {
          const list = this.activities || [];
          let total = 0;
          list.forEach(a => {
            const lostQty = Number(a?.lostQuantity || a?.lost || 0);
            const price = Number(a?.Product?.pricePurchase || 0);
            total += lostQty * price;
          });
          try { return this.formatMoney(total); } catch(e) { return total; }
        },
        stockOnHandValue() {
          const list = this.activities || [];
          let total = 0;
          list.forEach(a => {
            const qty = Number(a?.quantity || 0) + Number(a?.quantityReserved || 0);
            const price = Number(a?.Product?.pricePurchase || 0);
            total += qty * price;
          });
          try { return this.formatMoney(total); } catch(e) { return total; }
        }
    },
    mounted(){
      this.getActivities()
      this.fetchCategories()
      this.fetchWarehouses()
      this.setupProducts()
      
    },
    methods:{
      ...mapActions(["fetchCategories", "fetchWarehouses"]),
      async setupProducts(){
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
        };
        const res = await fetch(process.env.VUE_APP_URL+'/products', requestOptions)
        this.products = await res.json()
        this.productOptions = [];
        this.productOptions.push({ id: 0, text: "All"})
        this.products.forEach(product => {
          this.productOptions.push({ id: product.id, text: product.name})
        });
      },

      downloadCSV(dataRows, filename = 'manage_stock.csv') {
        if (!dataRows || dataRows.length === 0) {
          Swal.fire({ icon: 'info', title: 'No data to export', text: 'There are no rows to export.' });
          return;
        }

        // If DataTables returned plain arrays, convert to objects using known columns
        const sample = dataRows[0];
        let rows = dataRows;
        const isArrayRow = Array.isArray(sample);
        if (isArrayRow) {
          // Can't reliably map array rows here; fallback to processedData
          rows = (this.processedData && this.processedData.length) ? this.processedData : this.preprocessData(this.activities);
        }

        const csvContent = this.convertToCSV(rows);
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      },

      reinitializeTable(){
        this.dataTable.clear()
        this.dataTable.rows.add(this.preprocessData(this.activitiesDatas))
        this.dataTable.draw()
      },

      setActive(id){
        this.activeId= id
        //alert(this.activeId)
      },
      
      clear(){
        this.categoryId = "0"
        this.productId = "0"
        this.subCategoryId = "0"
        this.warehouseId = "0"
        this.stock = 'all'
        this.reinitializeTable()
      }, 

      exportToCSV() {
        // Prefer processedData (flattened rows). Fallback to preprocessing activities.
        const rows = (this.processedData && this.processedData.length)
          ? this.processedData
          : (this.activities && this.activities.length ? this.preprocessData(this.activities) : []);

        if (!rows || rows.length === 0) {
          Swal.fire({ icon: 'info', title: 'No data to export', text: 'There are no stock rows to export.' });
          return;
        }

        const csvContent = this.convertToCSV(rows);
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'manage_stock.csv';
        link.click();
      },

      convertToCSV(data) {
        // Define column order and human-friendly headers
        const columns = [
          'productName','productCode','productCategory','productSubCategory','productUnit',
          'onHand','qtyReserved','qtyAvailable','sohValue','stockLevel','warehouse'
        ];

        const headers = [
          'Product Description','Code','Category','Sub-Category','Unit',
          'On Hand','Qty Reserved','Qty Available','SOH Value(Kshs)','Stock Level','Warehouse'
        ];

        const escapeCell = (val) => {
          if (val === null || val === undefined) return '';
          // Convert objects to JSON string, otherwise toString
          let s = (typeof val === 'object') ? JSON.stringify(val) : String(val);
          // Escape double quotes
          s = s.replace(/"/g, '""');
          return '"' + s + '"';
        };

        const headerLine = headers.join(',') + '\n';
        const body = data.map(row => {
          return columns.map(col => escapeCell(row[col])).join(',');
        }).join('\n');

        return headerLine + body;
      },

      async getActivities () {
          const requestOptions = {
              method: "GET",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
          };
          try {
              this.loading = true
              const res = await fetch(process.env.VUE_APP_URL + '/inventory/activity', requestOptions);
              const data = await res.json();

              if (data.status === true) {
                console.log('API Response:', data);
                console.log('Activities count:', data.activities?.length);
                this.activities = data.activities;
                this.activitiesDatas = this.activities;
                this.processedData = this.preprocessData(this.activities);
                console.log('Processed data count:', this.processedData?.length);
              } else {
                Swal.fire({
                  icon: 'error',
                  title: 'Stock Item List not found',
                  text: data.message,
                });
              }
            } catch (error) {
              console.log("Error", error)
              Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while fetching the data.',
              });
            }finally{
              this.loading = false
              // Wait for DOM to update (table to become visible) before initializing DataTable
              this.$nextTick(() => {
                console.log('Initializing DataTable with processed data:', this.processedData?.length);
                if (this.dataTable) {
                  this.dataTable.destroy();
                  this.dataTable = null;
                }
                this.initializeDataTable();
              });
            }
          },



      preprocessData(rawData) {
        return rawData.map(item => {
          let sohValue =  "";
          let stockLevel =  "";
          let action = `<button  type="button" class="btn btn-default btn-sm dropdown-toggle" style="border: 1px solid black; margin-left: 10px;" @click="setActive(item.id)" data-bs-toggle="dropdown" aria-expanded="false" >Action</button>
                        <ul  class="dropdown-menu vertical-flex">
                            <li><a class="dropdown-item" href="/inventory/products/${item.Product.id}">View Product</a></li>
                            <li><a class="dropdown-item" href="/inventory/stocks/reserved/${item.id}">Reserve Stock</a></li>
                            <li><a class="dropdown-item" href="/inventory/stocks/adjustments/${item.id}">Adjust Stock</a></li>
                            <li><a class="dropdown-item" href="/inventory/stocks/transfers/${item.id}">Transfer Stock</a></li>
                            <li><a class="dropdown-item" href="/warehouses/activity/${item.id}">Activity</a></li>
                        </ul>
                    </div>`;

          if(item.Product?.pricePurchase){
            sohValue = this.formatMoney((item.quantity+ item.quantityReserved) * item.Product.pricePurchase);
          } else {
            sohValue = "-";
          }

          if(item.stock == 'low'){
            stockLevel = 'Low'
          } else if(item.stock == 'out'){
            stockLevel = 'Out of Stock'
          }else if(item.stock == 'normal'){
            stockLevel = 'Normal'
          }else if(item.stock == 'order'){
            stockLevel = 'Re-Order'
          }else if(item.stock == 'over'){
            stockLevel = 'Over Stocked'
          } else{
            stockLevel = ''
          }


          return {
            indexNo:"1",
            productName: this.checkNull(item.Product.name),  
            productCode: this.checkNull(item?.Product?.code),
            productCategory: this.checkNull(item?.Product?.Category?.category),
            productSubCategory: this.checkNull(item?.Product?.SubCategory?.category),
            productUnit: this.checkNull(item.Product?.unit?.unit),
            onHand: this.formatQty(item.quantity + item.quantityReserved),
            qtyReserved: this.formatQty(item.quantityReserved),
            qtyAvailable: this.formatQty(item.quantity),
            sohValue,
            stockLevel,
            warehouse: item.Warehouse.name,
            action
          };
        });
      },
      checkNull(category){
        if(category){
          return category;
        } else {
          return " - "
        }
      },
      initializeDataTable() {
        try{
          const vm = this;
          // Check if table element exists
          const tableElement = $(this.$el).find('#stocksTable');
          if (tableElement.length === 0) {
            console.warn('Table element #stocksTable not found');
            return;
          }
          
          this.dataTable = tableElement.DataTable({
            language: {
              paginate: {
                previous: '<i class="fa fa-chevron-left"></i>', // Custom icon for previous button
                next: '<i class="fa fa-chevron-right"></i>', // Custom icon for next button
              },
            },
            dom: 'Bfrtip',
            buttons: [  
            'colvis',
            'pageLength', 
            {
              extend: 'csv',
              text: 'Export CSV',
              className: 'btn btn-primary',
              exportOptions: {
                columns: ':visible', 
              },
              action: function (e, dt) {
                // Grab currently visible/filtered rows from DataTable and export via Vue method
                const rows = dt.rows({ search: 'applied' }).data().toArray();
                vm.downloadCSV(rows, 'manage_stock_filtered.csv');
              }
            },
            {
                extend: 'pdfHtml5',
                text: 'Export PDF',
                className: 'btn btn-primary',
                orientation: 'landscape', 
                exportOptions: {
                  columns: ':visible', 
                },
                customize: this.customizePDF,
              },
          ],
            data: this.processedData,
            columns: [
              { data: null },
              { data: 'productName' },
              { data: 'productCode' },
              { data: 'productCategory' },
              { data: 'productSubCategory' },
              { data: 'productUnit' }, 
              { data: 'onHand' }, 
              { data: 'qtyReserved' }, 
              { data: 'qtyAvailable' }, 
              { data: 'sohValue' }, 
              { data: 'stockLevel' }, 
              { data: 'warehouse' }, 
              { data: 'action' }
            ],
            columnDefs: [
              {
                targets: 0,
                searchable: false,
                orderable: false,
                render: (data, type, row, meta) => {
                  return meta.row + 1;
                },
              },
            ],
          });
        } catch(error){
          console.log({error})
        }
      },

    

      customizePDF(doc) {
      //const logoBase64 = this.convertToBase64(logo)
      //console.log(logoBase64)
      const profile = JSON.parse(localStorage.getItem('profile'))
      doc.pageMargins = [40, 40, 40, 40]; // Set margins for the entire page
      doc.defaultStyle.columnGap = 0
      doc.content[1].fillColor = '#f2f2f2'

      doc.header = () => {
        return {
          columns: [
            {
              width: '*',
              columns: [
                /* {
                     image: logoBase64,
                     width: 150, // Adjust the width as needed
                 },*/
                {
                  text: profile?.businessName,
                  alignment: 'left',
                  margin: [40, 15, 0, 40], // Adjust margins as needed
                  color: '#000000', // Orange color
                  bold: true,
                  fontSize: 14,

                }
              ]
            },
            {
              width: '*',
              stack: [
                {
                  text: 'Stocks',
                  alignment: 'right',
                  margin: [0, 15, 50, 0],
                  fontSize: 12,
                  color: '#000000'
                },
                {  
                  alignment: 'right',
                  margin: [300, 0, 0, 0],
                  width: '*',
                  columns: [
                    {
                      width: 'auto',
                      text: 'Date:',
                      alignment: 'right',
                      margin: [0, 0, 10, 0],
                      bold: true,
                    },
                    {
                      width: 'auto',
                      text: `${this.formatDate(new Date(), "true")}`,
                      alignment: 'right',
                      margin: [0, 0, 50, 0],
                      fontSize: 9
                    }
                  ]
                }
              ]
            }
          ],
          fillColor: '#000000'
        };
      },

      doc.footer = (currentPage, pageCount) => docFooter(currentPage, pageCount)

      doc.styles.title = {
        color: '#000000',
        fontSize: 13,
        margin: [80, 0, 0, 40],
      };
    },

      async search(){
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
            body: JSON.stringify({ 
                productId: this.productId,
                categoryId: this.categoryId,
                warehouseId: this.warehouseId,
                subCategoryId: this.subCategoryId,
                stock: this.stock
            })
        };
        const res = await fetch(process.env.VUE_APP_URL+'/inventory/activity/search', requestOptions)
        const data = await res.json()
        if(data.status == true){
            this.activities = data.activities
            this.dataTable.clear();
            this.dataTable.rows.add(this.preprocessData(this.activities));
            this.dataTable.draw();
            //this.processedData = this.preprocessData(this.activities);
        }else{
            Swal.fire({
                icon: 'error',
                title: 'Search failed. Try again',
                text: data.message
            })
        }
      },
      isSubCategory(element) {
        return element.id == this.categoryId;
      },
    },
    watch: {
      categoryId() {
      //  console.log(this.categoryId)
        if(this.categoryId == "0"){
          this.subCategoryId = 0;
          this.subcategories = [];
        } else {
          this.subcategories = []
          const category = this.categories.filter(this.isSubCategory);
          this.subcategories = category[0].subcategories;
        }
      }
    }
  }
  </script>